import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import { BienestarAgendaSnippet } from './bienestar/BienestarAgenda';
import {
  BienestarCrossPaths,
  BienestarLandingHero,
  BienestarProfessionalBlock,
  BienestarStoreCta,
  useBienestarPageMeta,
} from './bienestar/BienestarShared';
import {
  BIENESTAR_LANDING_HERO,
  goContact,
  goReservar,
  navigateTo,
  submitBienestarInterest,
} from './bienestar/bienestarNav';
import './BienestarPage.css';

const BienestarEntrenamientoPage = () => {
  const { t } = useTranslation();
  const [communityEmail, setCommunityEmail] = useState('');
  const [communitySubmitting, setCommunitySubmitting] = useState(false);
  const [communitySuccess, setCommunitySuccess] = useState(false);
  const [communityError, setCommunityError] = useState(null);

  useBienestarPageMeta('bienestarLandings.metaTrainingTitle', 'bienestarLandings.metaTrainingDesc');

  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bienestar-page bienestar-page--landing">
      <Header />
      <BienestarLandingHero
        kickerKey="bienestarLandings.trainingKicker"
        titleKey="bienestarLandings.trainingHeroTitle"
        leadKey="bienestarLandings.trainingHeroLead"
        ctaKey="bienestarHub.trainingCta"
        onCta={() => goReservar('entrenamiento-1a-1')}
        imageSrc={BIENESTAR_LANDING_HERO.training.src}
        fallbackSrc={BIENESTAR_LANDING_HERO.training.fallbackSrc}
      />

      <main className="bienestar-main bw-main">
        <div className="container bw-container">
          <article className="bw-session-card bw-session-card--training bw-session-card--solo">
            <span className="bw-session-tag">{t('bienestarLandings.trainingTag')}</span>
            <h2>{t('bienestarHub.trainingCardTitle')}</h2>
            <p className="bw-session-desc">{t('bienestarHub.trainingCardDesc')}</p>
            <ul className="bw-session-meta">
              <li><i className="fas fa-stopwatch" /> {t('bienestarHub.trainingCardMeta1')}</li>
              <li><i className="fas fa-calendar-day" /> {t('bienestarHub.trainingCardMeta2')}</li>
              <li><i className="fas fa-bed" /> {t('bienestarHub.trainingCardMeta3')}</li>
            </ul>
            <div className="bw-prices">
              <span className="bw-price-main">{t('bienestarHub.trainingPriceSingle')} <small>COP</small></span>
              <span className="bw-price-pack">{t('bienestarHub.trainingPricePack4')}</span>
              <span className="bw-price-pack">{t('bienestarHub.trainingPricePack8')}</span>
            </div>
            <p className="bw-contact-note">{t('bienestarHub.contactSoon')}</p>
            <button type="button" className="bw-cta" onClick={() => goReservar('entrenamiento-1a-1')}>
              {t('bienestarHub.trainingCta')}
            </button>
            <button type="button" className="bw-cta bw-cta--outline" onClick={() => goContact('entrenamiento-paquete')}>
              {t('bienestarLandings.packagesContactCta')}
            </button>
          </article>

          <BienestarProfessionalBlock variant="training" />

          <section id="comunidad-deportiva" className="bw-section bw-community">
            <header className="bw-section-header">
              <h2 className="bw-section-title">{t('bienestarHub.communityTitle')}</h2>
              <p className="bw-section-sub">{t('bienestarHub.communitySub')}</p>
            </header>
            {communitySuccess ? (
              <p className="bw-success"><i className="fas fa-check-circle" /> {t('bienestarHub.communitySuccess')}</p>
            ) : (
              <form
                className="bw-waitlist-form"
                onSubmit={(e) => submitBienestarInterest(e, 'comunidad-deportiva', communityEmail, {
                  setSubmitting: setCommunitySubmitting,
                  setSuccess: setCommunitySuccess,
                  setError: setCommunityError,
                  setEmail: setCommunityEmail,
                })}
              >
                <input
                  type="email"
                  placeholder={t('bienestarLandings.emailPlaceholder')}
                  value={communityEmail}
                  onChange={(e) => setCommunityEmail(e.target.value)}
                  required
                />
                <button type="submit" className="bw-cta" disabled={communitySubmitting}>
                  {communitySubmitting ? '...' : t('bienestarHub.communityCta')}
                </button>
                {communityError && <p className="bw-error">{communityError}</p>}
              </form>
            )}
          </section>

          <BienestarAgendaSnippet serviceSlug="entrenamiento-1a-1" />
          <BienestarStoreCta variant="training" />
          <BienestarCrossPaths current="training" />
          <button type="button" className="bw-back-hub" onClick={() => navigateTo('/bienestar')}>
            <i className="fas fa-arrow-left" aria-hidden="true" /> {t('bienestarLandings.backHub')}
          </button>
        </div>
      </main>
    </div>
  );
};

export default BienestarEntrenamientoPage;
